(function(){
  document.addEventListener('DOMContentLoaded', function(){
    const STORAGE_KEY = 'ch_active_type';
    const el = document.getElementById('ch-subnav');
    if (!el) return;

    // Menus in the persistent second row
    const menus = {
      bicycle: el.querySelector('.ch-subnav-menu--bicycle'),
      motorcycle: el.querySelector('.ch-subnav-menu--motorcycle')
    };

    // Prefer inline toggle beside the logo; fall back to (old) in-subnav toggle if present
    const toggles = {
      bicycle: document.querySelector('.ch-inline-btn--bicycle') || document.querySelector('.ch-subnav-toggle--bicycle'),
      motorcycle: document.querySelector('.ch-inline-btn--motorcycle') || document.querySelector('.ch-subnav-toggle--motorcycle')
    };

    function showMenu(type){
      Object.values(menus).forEach(m => m && m.classList.remove('is-active'));
      Object.values(toggles).forEach(b => b && b.classList.remove('is-active'));
      if (menus[type]) menus[type].classList.add('is-active');
      if (toggles[type]) toggles[type].classList.add('is-active');
      el.dataset.active = type;
      try { localStorage.setItem(STORAGE_KEY, type); } catch(e) {}
    }

    // Default to Bicycle; persist across pages
    const stored = localStorage.getItem(STORAGE_KEY);
    const startType = stored || el.dataset.default || 'bicycle';
    showMenu(startType);

    // Bind clicks
    Object.entries(toggles).forEach(([type, btn])=>{
      if (!btn) return;
      btn.addEventListener('click', function(e){
        e.preventDefault();
        showMenu(type);
      });
    });

    // Optional: clicking the top-level menu items acts like a toggle, not a link
    document.querySelectorAll('.header__menu-item--bicycle > a, .header__menu-item--motorcycle > a')
      .forEach(a => a.addEventListener('click', (e) => {
        e.preventDefault();
        showMenu(a.closest('.header__menu-item--bicycle') ? 'bicycle' : 'motorcycle');
      }));

    console.log('✅ ch-subnav.js loaded — active:', startType);
  });
})();
